import { ILaunchpadConfig } from './Launchpad';

const launchpadConfig: ILaunchpadConfig = {
  services: null,
};

export default launchpadConfig;
